import { render } from "./Footer.vue?vue&type=template&id=1b265345&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1b265345&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b265345"]])

export default __exports__